import { Button, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import configData from "../config.json";
//merge
//table
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate, useParams } from "react-router-dom";
//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getToken } from "../utils/auth"

function MultiPhotoes() {
  const params = useParams();
  const navigate = useNavigate();
  const [photoes, setPhotoes] = useState(null);
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const triggerCameraRequest = () => {
    setPhotoes(null);
    const token = getToken()
    let serial_string = atob(params.serials);
    let serial_list = JSON.parse(serial_string);
    let newBody = {
      serial_numbers: serial_list,
      retailer: params.retailer,
      store: params.store,
    };
    fetch(`${configData.SERVER_URL}/tablet/trigger_camera`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setPhotoes(data);
      })

      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  const resultCameraRequest = () => {
    setPhotoes(null);
    const token = getToken()
    let serial_string = atob(params.serials);
    let serial_list = JSON.parse(serial_string);
    let newBody = {
      serial_numbers: serial_list,
      retailer: params.retailer,
      store: params.store,
    };
    fetch(`${configData.SERVER_URL}/tablet/trigger_camera`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setPhotoes(data);
      })

      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  useEffect(() => {
    triggerCameraRequest();
  }, []);
  return (
    <div>
      <div>
        <button
          className="btn btn-primary"
          style={{ margin: "10px" }}
          onClick={triggerCameraRequest}
        >
          Trigger Camera
        </button>
        <button className="btn btn-primary" onClick={resultCameraRequest}>
          Refresh Result
        </button>
      </div>
      {photoes ? (
        <TableContainer
          component={Paper}
          sx={{
            alignItems: "center",
          }}
        >
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Serial Number</strong>
                </TableCell>
                <TableCell align="left">
                  <strong>Photos</strong>
                </TableCell>
                {/* <TableCell align="left">
                  <strong>Retry</strong>
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {photoes.map((item) => (
                <TableRow
                  key={item.serial_number}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {item.serial_number}
                  </TableCell>
                  <TableCell align="left">
                    {item.photoes.map((photo, index) => {
                      return (
                        <a href={photo} target="_blank" key={photo}>
                          photo{index + 1}{" "}
                        </a>
                      );
                    })}
                  </TableCell>
                  {/* <TableCell align="left">
                    <Button
                      variant="outlined"
                      size="small"
                      //onClick={(e) => ringTablet(e, event.mdm_id)}
                    >
                      Retry
                    </Button>
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <div style={{ textAlign: "center", marginTop: "10%" }}>
          <div>
            <h1>Please wait while we look for the images</h1>
          </div>
          <CircularProgress size={72} />
        </div>
      )}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default MultiPhotoes;
